module.exports = __webpack_public_path__ + "static/media/galerija_2017 (32).1e41ab08.jpg";